module.exports = __webpack_public_path__ + "static/media/LukeSkywalker.ec9cf713.png";